import { runtimeConfig } from '@/config/runtimeConfig'

export default {
	namespaced: true,
	state: {
		baseurl: runtimeConfig.apiUri,
		openLeftMenu: false,
		miniLeftMenu: false,
		openSearch: false,
		primaryColor: runtimeConfig.theme.primaryColor,
		secondaryColor: runtimeConfig.theme.secondaryColor,
		snackbarModel:{
			show: false,
			timeout: 1000,
			text: "",
			loading: false,
			color: "secondary",
			textColor: "white"
		},
		loadingGlobal:{
			showLoadingGlobal: false,
			text: "",
			indeterminate: false,
			size: 70,
			rotate: null,
			value: null
		},
		dialog: {
			show: false,
			titleText: "",
			titleColor: "",
			text: "",
			confirmBtn: false,
			confirmText: "",
			confirmAction: null,
			cancelText: "Ok",
			cancelAction: null,
			showTextBox: false,
			responseText: "",
			placeholderTextBox: "",
			focusOnField: false,
			typeTextBox: "string",
			showOption2: false,
			option2Text: "",
			option2Action: null,
			maxWidth: 450,
			options: [],
			optionSelect: null,
		},
		dc0: null,
		showSendNfeMailDialog: false,
		sendNfeMailDialogForm: null,
		openSelectCustomer: false,
		openProductSearch: false,
		openDialogFiscalPaf: false,
		openJustificationForFailure: false,
		dialogManager:{
			show: false,
			confirmAction: null,
			cancelAction: null,
			dc0arquivo: "",
			permission: "",
			showCheckBox: false,
			textCheckBox: "",
			valueCheckBox: false,
			useSimpleAuthentication: false,
			loggedUser: false,
			selectedUser: "",
		}
	},
	getters: {
		getDc0nome(state){
			if (state.dc0 && state.dc0.dc0arquivo){
				return state.dc0.dc0nome
			}
			return ""
		},
		getDialogManagerCheckBoxValue(state){
			return state.dialogManager.valueCheckBox
		}
	},
	mutations: {
		showSnackBar(state, model){
			state.snackbarModel = model
		},
		openGlobalLoading(state, {showLoadingGlobal = false, text = "", indeterminate = false, size = 64, rotate = null, value = null, opacity = 0.4}){
			state.loadingGlobal = {
				showLoadingGlobal,
				text,
				indeterminate,
				size,
				rotate,
				value,
				opacity
			}
		},
		resetDialog(state){
			state.dialog.show= false,
			state.dialog.titleText= "",
			state.dialog.titleColor= "",
			state.dialog.text= "",
			state.dialog.confirmBtn= false,
			state.dialog.confirmText= "",
			state.dialog.confirmAction= null,
			state.dialog.cancelText= "Ok",
			state.dialog.cancelAction= null
			state.dialog.showTextBox = false
			state.dialog.responseText = ""
			state.dialog.placeholderTextBox = ""
			state.dialog.focusOnField = false
			state.dialog.typeTextBox = "string"
			state.dialog.showOption2 = false
			state.dialog.option2Text = ""
			state.dialog.option2Action = null
			state.dialog.maxWidth = 450
			state.dialog.options = []
			state.dialog.optionSelect = null
		},
		openDialog(state, { titleText= "", titleColor= "", text= "", confirmBtn= false, confirmText= "", confirmAction= null, cancelText= "Ok", cancelAction= null, showTextBox = false, responseText = "", placeholderTextBox = "", focusOnField = false, typeTextBox = "string", showOption2 = false, option2Text = "", option2Action = null, maxWidth = 450, options = [], optionSelect = null, defaultTextBoxValue = null}){
			state.dialog.show = true
			state.dialog.titleText = titleText
			state.dialog.titleColor = titleColor
			state.dialog.text = text
			state.dialog.confirmBtn = confirmBtn
			state.dialog.confirmText = confirmText
			state.dialog.confirmAction = confirmAction
			state.dialog.cancelText = cancelText
			state.dialog.cancelAction = cancelAction
			state.dialog.showTextBox = showTextBox
			state.dialog.responseText = responseText
			state.dialog.placeholderTextBox = placeholderTextBox
			state.dialog.focusOnField = focusOnField
			state.dialog.typeTextBox = typeTextBox
			state.dialog.showOption2 = showOption2
			state.dialog.option2Text = option2Text
			state.dialog.option2Action = option2Action
			state.dialog.maxWidth = maxWidth
			state.dialog.options = options
			state.dialog.optionSelect = optionSelect
			state.dialog.defaultTextBoxValue = defaultTextBoxValue
		},
		openManagerDialog(state, { confirmAction, dc0arquivo, cancelAction = null, permission = "", showCheckBox = false, textCheckBox = "", useSimpleAuthentication = false, loggedUser = false, selectedUser = "" }){
			state.dialogManager.show = true
			state.dialogManager.confirmAction = confirmAction
			state.dialogManager.cancelAction = cancelAction
			state.dialogManager.dc0arquivo = dc0arquivo
			state.dialogManager.permission = permission
			state.dialogManager.showCheckBox = showCheckBox
			state.dialogManager.textCheckBox = textCheckBox
			state.dialogManager.valueCheckBox = false
			state.dialogManager.useSimpleAuthentication = useSimpleAuthentication
			state.dialogManager.loggedUser = loggedUser 
			state.dialogManager.selectedUser = selectedUser 
		},
		resetDialogManager(state){
			state.dialogManager.show = false
			state.dialogManager.confirmAction = null
			state.dialogManager.cancelAction = null
			state.dialogManager.dc0arquivo = ""
			state.dialogManager.permission = ""
			state.dialogManager.showCheckBox = false
			state.dialogManager.textCheckBox = ""
			state.dialogManager.loggedUser = false
			state.dialogManager.selectedUser = "" 
		}
	},
	actions: {
		showSnackBar(store, model){
			store.commit("showSnackBar", model)
		},
		openGlobalLoading(store, model){
			store.commit("openGlobalLoading", model)
		},
		resetDialog(store){
			store.commit("resetDialog")
		},
		resetDialogManager(store){
			store.commit("resetDialogManager")
		},
		openDialog(store, params){
			if(params.text != "Request failed with status code 401")
				store.commit("openDialog", params)
		},
		openManagerDialog(store, params){
			store.dispatch("dc4/findAllUsers", false, { root: true })
			store.commit("openManagerDialog", params)
		},
		async getDc0(store, dc0arquivo){
			if (!dc0arquivo){
				store.state.dc0 = null
				return false
			}

			let dc0 = await store.dispatch("dictionary/getDc0", dc0arquivo, { root:true })
			store.state.dc0 = dc0
			return dc0
		}
	}
}
